import { render, staticRenderFns } from "./ExSubscriptionStatusBadge.vue?vue&type=template&id=216dee30"
import script from "./ExSubscriptionStatusBadge.vue?vue&type=script&lang=js"
export * from "./ExSubscriptionStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports